import BossModel from "@/models/BossModel";

export default class UniqueSellingPoint extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'package/unique-selling-point';

    /**
     *
     * @type {string}
     */
    static entity = 'packageUniqueSellingPoints';

    static fields() {
        return {
            id: this.number(null).nullable(),
            sort_order: this.number(null).nullable(),
            text: this.attr(null),
            package_id: this.number(null).nullable(),
        }
    }
}
